import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function CameraMinifillSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.25 4.25c-.74 0-1.435.354-1.87.952l-.155.213a.812.812 0 01-.657.335H5.563A2.312 2.312 0 003.25 8.063v5.374a2.312 2.312 0 002.313 2.313h8.875a2.312 2.312 0 002.312-2.313V7.947a2.196 2.196 0 00-2.196-2.196.696.696 0 01-.562-.286l-.19-.262a2.312 2.312 0 00-1.87-.952H10.25zm.917 8.75a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM6.182 7.75a.75.75 0 100 1.5h.545a.75.75 0 000-1.5h-.545z",
    clipRule: "evenodd"
  }));
}

export default CameraMinifillSmall;
//# sourceMappingURL=CameraMinifillSmall.js.map